import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import Locale from "../../locales";

const DeleteDialog = ({ open, handleClose, confirmDelete, message = "" }) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle>{Locale.t("confirm_delete")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{Locale.t(message)}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{Locale.t("no")}</Button>
          <Button onClick={confirmDelete} color="error">
            {Locale.t("delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteDialog;
